import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { LoadingScreen } from './LoadingScreen';
import { useAuthStore } from '@shared/state';

export function AppLayout() {
  const loading = useAuthStore((s) => s.loading);

  if (loading) return <LoadingScreen />;

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
